(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/active-exclusions.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/active-exclusions.js');
'use strict';

const {
  useAtom
} = jotai;
const {
  activeExclusionsAtom,
  isNaExcludedAtom
} = svs.selfExclusion.atoms.selfExclusionAtoms;
const {
  Constants
} = svs.selfExclusion;
const {
  ExclusionView,
  NanExcluded,
  NeedsUnlock
} = svs.selfExclusion.components;
const ActiveExclusions = () => {
  const [activeExclusions] = useAtom(activeExclusionsAtom);
  const [naExcluded] = useAtom(isNaExcludedAtom);
  const needsUnlock = svs.selfExclusion.useNeedsUnlock(activeExclusions);
  return React.createElement(React.Fragment, null, React.createElement("section", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2",
    tabIndex: 0
  }, naExcluded && React.createElement("div", {
    className: "exclusion-pause-wrapper"
  }, React.createElement(NanExcluded, {
    activeExclusions: activeExclusions,
    url: Constants.URL.EXCLUSION
  })), !naExcluded && activeExclusions && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2"
  }, React.createElement(ExclusionView, {
    activeExclusions: activeExclusions
  })), needsUnlock && React.createElement("div", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-top-2"
  }, React.createElement(NeedsUnlock, {
    phone: Constants.PHONE
  })))), React.createElement("hr", {
    className: "exclusion-border-bottom"
  }));
};
svs.selfExclusion.components.ActiveExclusions = ActiveExclusions;

 })(window);